'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const MatterHistoryIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="MatterHistoryIcon">
      <svg
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        id="Task-List-Clock--Streamline-Ultimate"
        height="24"
        width="24"
      >
        <desc>Task List Clock Streamline Icon: https://streamlinehq.com</desc>
        <path
          d="m14.5 9.491 0 -4 -11 0 0 12.999 5 0.001"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M17.5 8.491v-5a1 1 0 0 0 -1 -1h-4.448a3.329 3.329 0 0 0 -6.1 0H1.5a1 1 0 0 0 -1 1v17a1 1 0 0 0 1 1h8"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6.5 8.491 5 0"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6.5 11.491 5 0"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m6.5 14.491 3 0"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="M11.5 17.491a6 6 0 1 0 12 0 6 6 0 1 0 -12 0Z"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
        <path
          d="m19.5 17.491 -2 0 0 -3"
          fill="none"
          stroke="#3d517b"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1"
        ></path>
      </svg>
    </SvgIcon>
  )
}

MatterHistoryIcon.propTypes = {
  sx: PropTypes.object
}
